<template>
  <section>
    <h2>APIログ閲覧ページ</h2>
    <p>
      ここでは、システム内でのAPIの利用状況を確認できます。<br />
    </p>
  </section>
  <section>
    <div v-for="item in APIlog" :key="item._id">
      <p>ユーザー名: {{ item.username }}</p>
      <p>通信ステート: {{ item.HttpStatusCode }}</p>
      <p>HTTPメソッド: {{ item.method }}</p>
      <p>サービスID:{{ item.serviceid }}</p>
      <p>エンドポイント: {{ item.endpointid }}</p>
      <p>リクエスト日時: {{ item.timestamp }}</p>
      <hr />
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useUserStore } from "../store/user.js";
const userStore = useUserStore();
const APIlog = ref([]);

async function getAPILog() {
  const logs = await userStore.getAPILog();
  APIlog.value = logs.reverse();
  APIlog.value.forEach(log => {
    log.timestamp = new Date(log.timestamp).toLocaleString();
  });
}

async function getuserAuthority() {
  const res =await userStore.getauthority();
  return res;
}
onMounted(async () => {
  // 管理者権限の確認
  const authority = await getuserAuthority();
  if (authority !== "admin") {
    alert("このページにアクセスする権限がありません。");
    window.location.href = "/";
  }
  getAPILog();
});
</script>